import { defineStore } from "pinia";
import { useCookie } from '#app';
import { localStorageBasicData, lowerString, isTokenValid } from "@/helpers";

export const useGlobalStore = defineStore('global', {
    state: () => {
        return {
            orderDetailsOffer: [],
            productData: {},
            orderDetails: [],
            orderDetailsWholesale: [],
            searchData:[],
            searchSuggestions:{},
            searchInputStatus:'start',
            searchInputValue:'',
            filterCategories:[],

            localStorageCopy: localStorageBasicData,
            showUserInputInOtp: {
                email: '',
                phone: ''
            },
            userInfo: {},
            notificationsCount: 0,
            forwardedStore: {},
            layout: {},
            hasTawkLoaded: false,
            savedHomepageData: {
                location: "",
                receivedData: {}
            },
            savedSingleProductData: {
                receivedData: {}
            },
            savedStoresData: {},
            savedCategoriesData: {
                receivedData: []
            },
            savedAttributesData: {
                data: [], 
                pagination: {
                    current_page: 1,
                    per_page: 10,
                    total: 1000
                }
            },
            savedStaticPagesData: {
                aboutUs: {},
                privacyPolicy: {},
                termsOfService: {}
            },
            savedProductspageData: {},
            savedSearchpageData: {},
            wizardData: {},
            showWizardModal: false,
            lastHrScrollPosition:{},
            displayMobileInstallationDialog: true,
            disableChatting: false,
            userGeoLocation: {lat: '', lng: ''},
            storeVerificationAmountInEGP: NaN,
            userStoresInVerification: []
        }
    },
    actions: {
        setOrderDetailsOffer(details) {
            this.orderDetailsOffer = details; // Action to set order details
        },
        clearOrderDetailsOffer() {
            this.orderDetailsOffer = []; // Action to clear order details
        },
        setProductData(details) {
            this.productData = details; // Action to set order details
        },
        clearProductData() {
            this.productData = {}; // Action to clear product data
        },
        setOrderDetailsWholesale(details) {
            this.orderDetailsWholesale = details; // Action to set order details
        },
        clearOrderDetailsWholesale() {
            this.orderDetailsWholesale = []; // Action to clear order details
        },
        setOrderDetails(details) {
            this.orderDetails = details; // Action to set order details
        },
        clearOrderDetails() {
            this.orderDetails = []; // Action to clear order details
        },
        setNewSearchData(newVal) {
            this.searchData = newVal
        },
        setNewSearchSuggestionData(newVal) {
            this.searchSuggestions = newVal
        },
        changeSearchInputStatus(newVal){
            const allStatus = ['start' , 'typing' ];

            if(allStatus.includes(newVal)){
                this.searchInputStatus = newVal
            }
        },
        setFilterCategories(newVal) {
            this.filterCategories = newVal
        },
        setSearchInputValue(newVal){
            this.searchInputValue = newVal
        },

        
        setLastHrScrollPosition(key,val){
            if(key==null || key==undefined  || val==undefined || val==undefined ) return
            this.lastHrScrollPosition[key]=val
        },
        setShowWizardModal(newVal) {
            this.showWizardModal = newVal
        },
        updateLocalStorageCopy(newVal) {
            if (!newVal) {
                return;
            }
            // updates pinia storage
            this.localStorageCopy = newVal;
            // updates the language cookie
            const cookieStorageCopy = useCookie('localStorageCopy');
            cookieStorageCopy.value = JSON.stringify({
                user: newVal.user || {},
                admin: newVal.admin || {},
                language: newVal.language || 'ar',
                isDarkMode: typeof newVal.isDarkMode == 'boolean' ? newVal.isDarkMode : false
            });
        },
        setShowUserInputInOtp(newVal) {
            this.showUserInputInOtp = { ...newVal }
        },
        setUserInfo(newVal) {
            this.userInfo = { ...newVal }
        },
        setNotificationsCount(newVal) {
            this.notificationsCount = newVal
        },
        setWizardData(newVal) {
            this.wizardData = newVal
        },
        updateForwardedStore(newVal) {
            this.forwardedStore = newVal;
        },
        setLayout(newVal) {
            this.layout = {
                ...this.layout,
                ...newVal
            }
        },
        updatehasTawkLoadingState(val) {
            this.hasTawkLoaded = val;
        },
        updateHomepageData({ receivedData, location }) {
            this.savedHomepageData = {
                ...this.savedHomepageData,
                ...(receivedData && { receivedData }),
                ...(location && { location }),
            }
        },
        updateSingleProductData(receivedData) {
            this.savedSingleProductData = { receivedData };
        },
        updateCategoriesData(receivedData) {
            this.savedCategoriesData = { receivedData };
        },
        updateStoresData(receivedData, clear = false) {
            if (!clear && (receivedData && Object.keys(receivedData).length)) {
                this.savedStoresData = {
                    ...this.savedStoresData,
                    ...(receivedData && { ...receivedData }),
                }
            } else {//clear
                this.savedStoresData = {}
            }
        },
        updateAttributesData(newData) {
            this.savedAttributesData = {
                data: newData.data || [],
                pagination: {
                    current_page: newData.pagination?.current_page || 1,
                    per_page: newData.pagination?.per_page || 10,
                    total: newData.pagination?.total || 1000
                }
            };
        },
        updateProductspageData(val) {
            if (val && Object.keys(val).length) {
                this.savedProductspageData = {
                    ...this.savedProductspageData,
                    ...(val && { ...val }),
                }
            } else {//clear
                this.savedProductspageData = {}
            }
        },
        updateSearchpageData(val) {
            if (val && Object.keys(val).length) {
                this.savedSearchpageData = {
                    ...this.savedSearchpageData,
                    ...(val && { ...val }),
                }
            } else {//clear
                this.savedSearchpageData = {}
            }
        },
        updateSavedStaticPagesData(val){
            const {response = {}, key = ''} = val;
            if(Object.hasOwn(this.savedStaticPagesData, key)){
                this.savedStaticPagesData = {
                    ...this.savedStaticPagesData,
                    [key]: response
                }
            }
        },
        updateDisplayingMobileInstallationDialog(newVal){
            this.displayMobileInstallationDialog = newVal;
        },
        updateDisableChattingState(newState){
            this.disableChatting = newState;
        },
        async updateUserGeoLocation({lat, lng}){
            this.userGeoLocation = {lat, lng};
        },
        updateStoreVerificationAmountInEGP(price){
            this.storeVerificationAmountInEGP = price || NaN
        },
        updateUserStoresInVerification(payload){
            this.userStoresInVerification = payload || {};
        },
        clearAttributesData() {
            this.savedAttributesData = {};
        }
    },
    
    getters: {
        getOrderDetailsOffer: (state) => state.orderDetailsOffer,
        getProductData: (state) => state.productData,
        getOrderDetails: (state) => state.orderDetails,
        getOrderDetailsWholesale: (state) => state.orderDetailsWholesale,
        getFilterCategories:(state)=>state.filterCategories,
        getSearchInputStatus:(state)=>state.searchInputStatus,
        getSearchInputValue:(state)=>state.searchInputValue,
        getStoreSearchSuggestions:(state)=> state.searchSuggestions,
        getStoreSearchData: (state)=> state.searchData,
        isRTL: (state) => lowerString(state?.localStorageCopy?.language) === 'ar',
        currentAdminRole: (state) => lowerString(state?.localStorageCopy?.admin?.role) || '',
        currentUserRole: (state) => lowerString(state?.localStorageCopy?.user?.role) || '',
        isUserLogged: (state) => isTokenValid(state?.localStorageCopy?.user?.token) || false,
        getForwardedStore: (state) => state.forwardedStore || {},
        getLocalStorageCopy: (state) => state?.localStorageCopy || {},
        getCategories: (state) => state?.localStorageCopy?.categories || [],
        getFavoriteProducts: (state) => state?.localStorageCopy?.favoriteProducts || [],
        getCartCounter: (state) => state?.localStorageCopy?.user?.cart_items_count || 0,
        getSavedHomepageData: (state) => state?.savedHomepageData || {},
        getSingleProductData: (state) => state?.savedSingleProductData?.receivedData || {},
        getCategoriesData: (state) => state?.savedCategoriesData?.receivedData || [],
        getStoredUserGeoLocation: (state) => state.userGeoLocation || {lat: '', lng: ''},
        getStoreverificationAmountInEGP: (state) => state.storeVerificationAmountInEGP || NaN,
        getUserStoresInVerification: (state) => state.userStoresInVerification || {},
    }
});